import axios from "axios";

export function loadCampaign(id) {
    return axios.get(
        process.env.REACT_APP_API_HOST + `/campaigns/${id}/`
    )
}

export function loadAllCampaigns(include_public = false) {
    return axios.get(
        process.env.REACT_APP_API_HOST + `/campaigns/?include_public=${include_public}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token'),
            }
        }
    )
}

export function patchCampaign(campaign_id, data) {
    return axios.patch(
        process.env.REACT_APP_API_HOST + `/campaigns/${campaign_id}/`,
        data
    )
}

export function getCampaignBalanceE6(campaign_id) {
    return axios.get(
        process.env.REACT_APP_API_HOST + `/campaign/balance/?campaign_id=${campaign_id}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token'),
            }
        }
    )
}